/* Component to Create a Tracker */
import React, { useState } from "react"
import useDepartmentPostsDepartments from "../../hooks/useDepartmentPostsDepartments"
import DatePicker from "react-datepicker";
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import styles from "../../styles/Indexes.module.css"
import btnStyles from "../../styles/Button.module.css"
import Alert from "react-bootstrap/Alert"
import { axiosReq, axiosInstance } from "../../api/axiosDefaults"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import toast from "react-hot-toast"
import { useLocation } from "react-router-dom"
import { useCurrentUser } from "../../contexts/CurrentUserContext"

const ProTrackerCreate = ({ setShowAdd, setproTrackers }) => {
  const host = useHostName()
  const location = useLocation()
  const currentUser = useCurrentUser()
  const { departments: departmentList, scenes } = useDepartmentPostsDepartments()
  const [errors, setErrors] = useState({})

  const [postData, setPostData] = useState({
    scene: "",
    name: "",
    department: "",
    level: "",
    status: "new",
  });

  const {
    scene, // It is the scene id
    name,
    department,
    level,
    status,
  } = postData;

  const [doneBy, setDoneBy] = useState("")
  const [doneByDate, setDoneByDate] = useState(null)

  const handleDate = (date) => {
    if (!date) {
      setDoneBy("")
      setDoneByDate(null)
      return
    }
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const dd = String(date.getDate()).padStart(2, "0")
    setDoneBy(`${yyyy}-${mm}-${dd}`)
    setDoneByDate(date)
  }

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const parseProjectCategoryType = (raw) => {
    if (raw == null || raw === "") return null
    if (typeof raw === "string") {
      try {
        return JSON.parse(raw)
      } catch {
        return raw
      }
    }
    return raw
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const projectType = parseProjectCategoryType(currentUser?.project_category_type)
    const episodeFromQuery = new URLSearchParams(location.search || "").get("episode")
    const parsedEpisode = Number(episodeFromQuery)
    const parsedScene = scene === "" || scene == null ? null : Number(scene)
    const payload = {
      scene:
        parsedScene != null && Number.isFinite(parsedScene) ? parsedScene : null,
      name,
      department,
      level,
      status,
      done_by: doneBy || null,
      episode:
        projectType === "Television" && Number.isFinite(parsedEpisode)
          ? parsedEpisode
          : null,
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axiosReq.post(
          "/production-tracker/items/",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        if (response?.success === false) {
          throw response.error
        }
        const { data } = response
        setShowAdd(false)
        setproTrackers((prevTracker) => ({
          ...prevTracker,
          count: (prevTracker?.count ?? prevTracker?.results?.length ?? 0) + 1,
          results: [data, ...(prevTracker.results || [])],
        }));
        toast.success(`Tracker Item Added`);
      } else {
        const response = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/production-tracker/items/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error
        }
        const { data } = response
        setShowAdd(false)
        setproTrackers((prevTracker) => ({
          ...prevTracker,
          count: (prevTracker?.count ?? prevTracker?.results?.length ?? 0) + 1,
          results: [data, ...(prevTracker.results || [])],
        }));
        toast.success(`Tracker Item Added Successfully!`);
      }
    } catch (err) {
      console.log(err)
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        "Failed to create tracker item."
      toast.error(backendError)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mr-3 px-3 px-md-5`}
        onClick={() => setShowAdd(false)}
      >
        Cancel
      </Button>
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} m1-3 px-3 px-md-5`}
        type="submit"
      >
        Create
      </Button>
    </div>
  )

  return (
    <div className="py-3" >
      <Row>
        <Col xs={12} md={{ span: 10, offset: 1 }}>
          <p className={`text-center ${styles.SubTitle}`}
            style={{ textTransform: 'uppercase' }}>Create Tracker Item</p>
          <Form className={`text-center px-3 ${styles.Back}`}
            onSubmit={handleSubmit}>
            <Row className="mt-3">
              {/* name  */}
              <Col xs={12} md={4}
                className="px-0 px-md-2 py-2 d-flex justify-content-center">
                <Form.Group controlId="name" className={`${styles.Width90} `} >
                  <Form.Label className={`text-center ${styles.BoldScene}`} >Item Name</Form.Label>
                  <Form.Control
                    type="text"
                    className={styles.Input}
                    name="name"
                    value={name}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.name?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              {/* scene number */}
              <Col xs={6} md={4} className="py-2 px-0 px-md-2 d-flex justify-content-center" >
                <Form.Group controlId="number" className={`${styles.Width90} text-center`}  >
                  <Form.Label className={`text-center ${styles.BoldScene}`} >Scene Number</Form.Label>
                  <Form.Control as="select"
                    className={styles.Input}
                    name="scene"
                    value={scene === "" || scene == null ? "" : String(scene)}
                    onChange={handleChange}
                    aria-label="scene number select">
                    <option value=""></option>
                    {scenes.results?.length > 0 &&
                      scenes.results.map((scene) => (
                        <option key={scene.id} value={String(scene.id)}>
                          {scene.number}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
                {errors?.scene?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              {/* department as select */}
              <Col xs={6} md={4} className="py-2 px-0 px-md-2 d-flex justify-content-center" >
                <Form.Group controlId="department" className={`${styles.Width90} `} >
                  <Form.Label className={`${styles.BoldScene}`} >Department</Form.Label>
                  <Form.Control as="select"
                    name="department"
                    value={department}
                    className={styles.Input}
                    onChange={handleChange}
                    aria-label="department select">
                    <option value=""></option>
                    {departmentList.map(({ value, label }) => (
                      <option key={value} value={String(value)}>
                        {label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {errors?.department?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
            <Row>
              {/* level as select */}
              <Col xs={6} md={4} className="py-2 px-0 px-md-2 d-flex justify-content-center" >
                <Form.Group controlId="level" className={`${styles.Width90} `} >
                  <Form.Label className={`${styles.BoldScene}`} >Level</Form.Label>
                  <Form.Control as="select"
                    className={styles.Input}
                    name="level"
                    value={level}
                    onChange={handleChange}
                    aria-label="level select">
                    <option></option>
                    <option value="major">Major</option>
                    <option value="medium">Medium</option>
                    <option value="minor">Minor</option>
                  </Form.Control>
                </Form.Group>
                {errors?.level?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              {/* status as select*/}
              <Col xs={6} md={4} className="py-2 px-0 px-md-2 d-flex justify-content-center" >
                <Form.Group controlId="stat" className={`${styles.Width90} `} >
                  <Form.Label className={`${styles.BoldScene}`} >Status</Form.Label>
                  <Form.Control as="select"
                    className={styles.Input}
                    name="status"
                    value={status}
                    onChange={handleChange}
                    aria-label="stat select">
                    <option className={`${styles.StatsNew}`} value="new">New</option>
                    <option className={`${styles.StatsStart}`} value="started">Started</option>
                    <option className={`${styles.StatsDone}`} value="done">Done</option>
                  </Form.Control>
                </Form.Group>
                {errors?.status?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              {/* done by */}
              <Col xs={12} md={4} className="py-2 px-2">
                <p className={`${styles.BoldScene} pb-2`} >Done By</p>
                <div className="px-3 d-flex justify-content-center">
                  <Form.Group controlId="doneby" className={`${styles.Width90} text-center`} >
                    <DatePicker
                      className={`${styles.Input} py-0 my-0`}
                      selected={doneByDate}
                      onChange={(date) => handleDate(date)}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="YYYY-MM-DD"
                    />
                  </Form.Group>
                  {errors?.done_by?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className={` my-3`} >{buttons} </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default ProTrackerCreate
